module.exports = __webpack_public_path__ + "static/media/avatar-richard.ef634180.png";